import React from 'react'
import { Card, CardContent, Typography, Box } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { getTrendColor } from '../Common/constants/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// fal icons — consistent with rest of the project
const CARD_ICON_MAP = {
  'Submitted to NAIC':      ['fal', 'paper-plane'],
  'Assessment Complete':    ['fal', 'circle-check'],
  'Pending Action (RFI)':   ['fal', 'circle-question'],
  'Do Not Load':            ['fal', 'ban'],
  'Failed Acknowledgement': ['fal', 'triangle-exclamation'],
  'Error in Submission':    ['fal', 'circle-exclamation']
}

const useStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    transition: 'box-shadow 0.2s',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: '50%',
    flexShrink: 0
  },
  label: {
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: 1.2,
    // clamp to 2 lines so all cards stay same height
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  description: {
    lineHeight: 1.3
  }
}))

function MetricsCard({ label, count, trend, color, description }) {
  const classes = useStyles()
  const theme = useTheme()
  const trendColor = getTrendColor(theme, trend)
  const trendSymbol = trend > 0 ? '\u2197' : trend < 0 ? '\u2198' : '\u2192'
  const iconKey = CARD_ICON_MAP[label] || ['fal', 'circle-exclamation']

  return (
    <Card className={classes.card}>
      {/* top accent bar */}
      <Box style={{ height: 4, backgroundColor: color }} />

      <CardContent className={classes.cardContent}>
        {/* icon + label row */}
        <Box display='flex' alignItems='flex-start' mb={1} style={{ gap: 8 }}>
          <Box
            className={classes.iconWrapper}
            style={{ backgroundColor: color + '22' }}
          >
            <FontAwesomeIcon icon={iconKey} style={{ fontSize: 15, color }} />
          </Box>
          <Typography
            variant='caption'
            className={classes.label}
            style={{ color: theme.palette.text.secondary }}
          >
            {label}
          </Typography>
        </Box>

        {/* big count */}
        <Typography style={{ fontWeight: 700, fontSize: '2rem', lineHeight: 1 }}>
          {count}
        </Typography>

        {/* trend row */}
        <Box display='flex' alignItems='center' mt={0.5} style={{ gap: 4 }}>
          <Typography style={{ fontSize: '0.8rem', color: trendColor, fontWeight: 500 }}>
            {trendSymbol} {trend > 0 ? '+' : ''}{trend} vs last week
          </Typography>
        </Box>

        {/* caption */}
        <Typography
          variant='caption'
          style={{ textTransform: 'uppercase', letterSpacing: '0.05em', color: theme.palette.text.disabled }}
        >
          Last 30 days
        </Typography>

        {/* faint divider */}
        <Box className={classes.divider} />

        {/* and  */}
        {description && (
          <Typography
            variant='caption'
            className={classes.description}
            style={{ color: theme.palette.text.secondary }}
          >
            {description}
          </Typography>
        )}
      </CardContent>
    </Card>
  )
}

export default MetricsCard